module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tutor",
    attrs: {
      "id": "members"
    }
  }, [_c('div', {
    staticClass: "index-list-tutor"
  }, [_c('ul', {
    staticClass: "index-list"
  }, [_vm._m(0), _vm._l((_vm.tutor.items), function(name, $index) {
    return _c('li', [_c('img', {
      attrs: {
        "src": ['/static/img/' + _vm.members[name].pic],
        "alt": _vm.members[name].name
      }
    }), _c('div', {
      staticClass: "tutor-info"
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.members[name].sponsor),
        expression: "members[name].sponsor"
      }],
      staticClass: "sup",
      attrs: {
        "src": require("../assets/imgs/sup.png")
      }
    }), _c('h3', [_vm._v(_vm._s(_vm.members[name].name))]), _c('h4', [_vm._v(_vm._s(_vm.members[name].company))]), _c('p', [_vm._v(_vm._s(_vm.members[name].position))])])])
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index-list-title"
  }, [_c('h1', [_vm._v("加入他们")]), _c('h1', {
    staticClass: "two"
  }, [_vm._v("成为他们")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f0bd49ec!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tutor.vue
// module id = 211
// module chunks = 1